import { route, tag, type PageTour } from '../pageTour';

export const platformHealthTour: PageTour = {
  id: 'page-platform-health',
  version: 1,
  title: 'Platform Health',
  summary: 'Health of the cloud platform and its services.',
  match: route('/platform-health'),
  steps: [
    {
      target: tag('platform-tabs'),
      title: 'Three views',
      description:
        'Performance shows the cloud server right now, History shows how it has trended over the last day, and Sites lists every site with its own health and an Inspect button.',
      side: 'bottom',
    },
    {
      target: tag('platform-resources'),
      title: 'Cloud server load',
      description:
        'CPU, memory, disk, load and swap for the cloud server itself. A bar turning amber or red is your early warning before the platform slows down.',
      side: 'bottom',
    },
    {
      target: tag('platform-connections'),
      title: 'Site connections',
      description:
        'How many sites hold a live connection to the cloud right now, and how many have dropped. A site that is disconnected here cannot be viewed or managed remotely.',
      side: 'top',
    },
    {
      target: tag('platform-sites-summary'),
      title: 'Sites at a glance',
      description: 'Totals across all your sites: online, offline, active tunnels and people currently watching video.',
      side: 'top',
    },
    {
      target: tag('platform-refresh'),
      title: 'Always up to date',
      description: 'The page refreshes itself every few seconds, so you can leave it open as a status board.',
      side: 'top',
    },
  ],
};
